import React, { useEffect, useRef } from "react";
import "./ModelViewer.css";
// import Spline from '@splinetool/react-spline';


export default function Scene() {
  const viewerRef = useRef(null);

  useEffect(() => {
    const viewer = viewerRef.current;

    if (viewer) {
      // Add custom events if needed
      viewer.addEventListener("load", () => {
        console.log("Spline scene loaded!");
      });

      viewer.addEventListener("follow", (event) => {
        console.log("Follow event triggered:", event);
      });
    }

    return () => {
      if (viewer) {
        viewer.removeEventListener("load", () => console.log("Spline scene unloaded."));
        viewer.removeEventListener("follow", () => console.log("Follow event listener removed."));
      }
    };
  }, []);

  useEffect(() => {
    // Select the logo element by its ID
    const logoElement = document.getElementById("logo");
    if (logoElement) {
      // Example: Remove the logo element
      logoElement.style.display = "none"; // Hides the logo
      // OR logoElement.remove(); // Removes the element from the DOM
    }
  }, []);

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        background: "#000",
      }}
    >
      <spline-viewer
        ref={viewerRef}
        url="https://prod.spline.design/6yzeenA-urUBCJsN/scene.splinecode"
        events-target="global"
        style={{
          width: "100%",
          height: "100%",
        }}
      ></spline-viewer>
    </div>
  );
}
